import api from '@/api'

const actions = {
  async getData ({commit}, params) {
    try {
      console.log('action: ', params)
      const {data} = await api.userApi.getClientFeedback(params)
      return data
    } catch (err) {
      return {
        items: [],
        total: 0,
        pageCount: 0,
      }
    }
  },
  async editRemark ({commit}, params) {
    const {code} = await api.userApi.updateFeedbackRemark(params)
    return {code}
  },
}
export default {
  namespaced: true,
  actions,
}
